import classNames from "@calcom/ui/classNames";

export function Logo({
  small,
  icon,
  inline = true,
  className,
  src = "/ikigai-logo.svg",
}: {
  small?: boolean;
  icon?: boolean;
  inline?: boolean;
  className?: string;
  src?: string;
}) {
  return (
    <h3 className={classNames("logo", inline && "inline", className)}>
      <strong>
        {icon ? (
          <img className="mx-auto w-9 " alt="Ikigai Real Estate" title="Ikigai Real Estate" src="/ikigai-icon.svg" />
        ) : (
          <img
            className={classNames(small ? "h-4 w-auto" : "h-5 w-auto", "")}
            alt="Ikigai Real Estate"
            title="Ikigai Real Estate"
            src={src}
          />
        )}
      </strong>
    </h3>
  );
}
